'use strict';

/**
 * Top Button
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	// let numberRating = 0;
	// let votedRating = 13;

	$('.rating-blog__label').on('click', function () {
		let it = $(this);

		let value = it.data('value');

		$.ajax({
			url: it.closest('.rating-blog__mark').data('url'),
			type: 'POST',
			dataType: 'JSON',
			data: {
				number: value,
				id: it.closest('.rating-blog__mark').data('id')
			},
			success: function (data) {
				// if (data.success) {}
				// $('.rating-blog__status').addClass('rating-blog__status--ok');

				$.magnificPopup.open({
					items: {
						src: `<div class="noty magnific-popup magnific-popup--noty">
						<div class="noty__message">` + data.message + `</div>
						<button class="button button--yellow js-mfp-close">
							<span class="button__text">Close</span>
						</button>
					</div>`,
						type: 'inline'
					},
					removalDelay: 200,
					mainClass: 'zoom-in',
					autoFocusLast: false,
					fixedContentPos: false
				});

				$('[data-rating]').text(data.number);
				$('[data-voted]').text(data.voted);

				it.closest('.rating-blog__mark').removeClass('is-active').addClass('is-disabled');
			}
		});
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/rating.js